import { HTMLAttributes } from 'react'

import Container from '@/components/base/Container'
import Grid from '@/components/base/Grid'
import Motion from '@/components/base/Motion'
import Section from '@/components/base/Section'

import { logoWallRevealAnimation } from './animations'
import { cn } from '@/lib/utils'
import { WPImage } from '@/types'

export type LogoWallProps = HTMLAttributes<HTMLDivElement> & {
  logos: {
    logo: WPImage
  }[]
}

const LogoWall = ({ logos, ...props }: LogoWallProps) => {
  return (
    <Motion animation={logoWallRevealAnimation}>
      <Section {...props}>
        <Container>
          <Grid className="gap-spacing-sm">
            {logos.map((item, index) => (
              <div
                key={index}
                className={cn(
                  index === 0 && 'lg:col-start-3',
                  'bg-gradient-to-b from-[#545454] to-[#303030] p-[1px]',
                  'col-span-2 flex items-center justify-center md:col-span-3 lg:col-span-2'
                )}
                data-motion-logo
              >
                <div className="flex aspect-[0.9] h-full w-full flex-col items-center justify-center bg-[#292929] px-spacing-sm py-spacing-lg">
                  <img src={item.logo.url} alt={item.logo.alt} />
                </div>
              </div>
            ))}
          </Grid>
        </Container>
      </Section>
    </Motion>
  )
}

export default LogoWall
